// client/src/pages/Settings.js
import React, { useEffect, useState } from 'react';
import { Card, Button, Spinner, Alert, Row, Col, Form } from 'react-bootstrap';
import useCsgo from '../hooks/useCsgo';

function Settings() {
  const { config, loading, error, fetchConfig, updateConfig } = useCsgo();
  const [form, setForm] = useState(null);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  useEffect(() => {
    if (config) {
      setForm({
        steamId: config.steamId || '',
        csfloatSellFeePct: String(config.csfloatSellFeePct ?? ''),
        csfloatWithdrawFeePct: String(config.csfloatWithdrawFeePct ?? ''),
        conversionFeePct: String(config.conversionFeePct ?? '')
      });
    }
  }, [config]);

  const set = (k) => (e) => {
    setSaved(false);
    setForm((f) => ({ ...f, [k]: e.target.value }));
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaved(false);
    await updateConfig(form);
    setSaved(true);
  };

  return (
    <div className="p-4">
      <h1 className="mb-4">Paramètres</h1>

      <Row>
        <Col md={7}>
          <Card className="shadow-sm">
            <Card.Header as="h5">CS:GO — Réglages</Card.Header>
            <Card.Body>
              {error && <Alert variant="danger">{error}</Alert>}
              {saved && (
                <Alert variant="success" dismissible onClose={() => setSaved(false)}>
                  Réglages enregistrés.
                </Alert>
              )}

              {!form ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <Form onSubmit={handleSave}>
                  <Form.Group className="mb-3">
                    <Form.Label>SteamID64</Form.Label>
                    <Form.Control
                      value={form.steamId}
                      onChange={set('steamId')}
                      placeholder="76561198294975584"
                    />
                    <Form.Text className="text-muted">
                      Utilisé pour identifier tes ventes lors de la réconciliation CSFloat.
                    </Form.Text>
                  </Form.Group>

                  <Row className="g-3">
                    <Col sm={4}>
                      <Form.Label>Frais de vente (%)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={form.csfloatSellFeePct}
                        onChange={set('csfloatSellFeePct')}
                      />
                    </Col>
                    <Col sm={4}>
                      <Form.Label>Frais de retrait (%)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={form.csfloatWithdrawFeePct}
                        onChange={set('csfloatWithdrawFeePct')}
                      />
                    </Col>
                    <Col sm={4}>
                      <Form.Label>Frais de conversion (%)</Form.Label>
                      <Form.Control
                        type="number"
                        step="0.1"
                        value={form.conversionFeePct}
                        onChange={set('conversionFeePct')}
                      />
                    </Col>
                  </Row>
                  <Form.Text className="text-muted d-block mb-3">
                    Seul le <strong>frais de vente</strong> est déduit des profits (prélevé par
                    CSFloat sur chaque vente). Les frais de retrait/conversion ne s'appliquent qu'à
                    l'encaissement vers la banque et ne sont plus déduits des profits — conservés
                    ici à titre indicatif.
                  </Form.Text>

                  <Button type="submit" variant="primary" disabled={loading.saveConfig}>
                    {loading.saveConfig ? 'Enregistrement...' : 'Enregistrer'}
                  </Button>
                </Form>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default Settings;
